import {useRef} from "react";
import {
  AnimatedWrapLogout,
  ControlsWrapper,
  TgContactWrapper
} from "widgets/profile/ui/styles.ts";
import {CSSTransition} from "react-transition-group";
import {logout, mergeRefs} from "shared/helpers";
import Button from "@atomaro/ui-kit/components/Button/Button/Button";
import {useResize} from "../../../../app/lib/hooks/useResize.ts";
import {useHudOverlay} from "widgets/hud/model/overlayStore.ts";
import {useOutClick} from "../../../../app/lib/hooks/useOutClick.ts";



export const LogoutModal = () => {
  const isScreenMd = useResize()
  const openId = useHudOverlay((s) => s.openId);
  const close = useHudOverlay((s) => s.close);
  const isOpen = openId === "logout";
  const nodeRef = useRef<HTMLDivElement | null>(null);
  const containerRef = useRef<HTMLDivElement | null>(null);
  
  useOutClick(containerRef, close);
  
  if (isScreenMd) return (
    <>
      <CSSTransition
        in={isOpen}
        timeout={{ enter: 200, exit: 150 }}
        classNames="hud-slide"
        unmountOnExit
        nodeRef={nodeRef}
      >
        <AnimatedWrapLogout
          ref={mergeRefs(containerRef, nodeRef)}
          role="dialog"
          aria-modal="true"
        >
          <TgContactWrapper>
            Вы уверены что хотите <br/> выйти из аккаунта?
            <ControlsWrapper>
              <Button
                label={"Отмена"}
                variant={"secondary"}
                size={"m"}
                onClick={close}
              />
              
              <Button
                label={"Выйти"}
                variant={"primary"}
                size={"m"}
                onClick={logout}
              />
            </ControlsWrapper>
            
          
          </TgContactWrapper>
        </AnimatedWrapLogout>
      </CSSTransition>
    </>
  );
}

